import styled from 'styled-components';
import { LINE_COLOR } from 'constants/theme';

export const BarChartWrapper = styled.div`
  .recharts-cartesian-axis-line {
    stroke: ${LINE_COLOR};
  }
`;
